import { render } from "./Sobre.vue?vue&type=template&id=013740e7&scoped=true"
import script from "./Sobre.vue?vue&type=script&lang=js"
export * from "./Sobre.vue?vue&type=script&lang=js"

import "./Sobre.vue?vue&type=style&index=0&id=013740e7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013740e7"]])

export default __exports__